import * as React from 'react';

var _path, _g, _defs;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgAllContracts = function SvgAllContracts(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 80 80"
    }, props), /*#__PURE__*/ React.createElement("mask", {
        id: "mask0_66_24776",
        width: 80,
        height: 80,
        x: 0,
        y: 0,
        maskUnits: "userSpaceOnUse",
        style: {
            maskType: "alpha"
        }
    }, _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#D9D9D9",
        d: "M0 0h80v80H0z"
    }))), _g || (_g = /*#__PURE__*/ React.createElement("g", {
        mask: "url(#mask0_66_24776)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint0_linear_66_24776)",
        fillOpacity: 0.16,
        d: "M18.23 67.333q-1.723 0-2.977-1.253T14 63.103V27.846q0-1.724 1.445-3.17t3.17-1.445h21.077q.497 0 .977.21t.82.528l2.53 2.595h25.366q1.34 0 2.432.74 1.093.741 1.606 1.824l3.82 5.898q1.264 0 2.046.987t.5 2.25l-7.27 25.942q-.435 1.551-1.545 2.34t-2.743.788z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint1_linear_66_24776)",
        d: "M14.23 63.333q-1.723 0-2.977-1.253T10 59.103V23.846q0-1.724 1.445-3.17t3.17-1.445h21.077q.497 0 .977.21t.82.528l2.53 2.595h25.366q1.34 0 2.432.74 1.093.741 1.606 1.824h-30.48l-3.334-3.333H14.615q-.898 0-1.474.577-.577.576-.577 1.474v34.872q0 .705.353 1.154t.93.769l7.627-27.724a2.8 2.8 0 0 1 .993-1.363q.705-.528 1.552-.528h49.225q1.262 0 2.044.987.783.987.5 2.25L68.52 60.205q-.435 1.551-1.545 2.34t-2.743.788zm2.302-2.564h49.205l7.385-27.18H23.917z"
    }))), _defs || (_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint0_linear_66_24776",
        x1: 14.688,
        x2: 78.946,
        y1: 45.282,
        y2: 45.282,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint1_linear_66_24776",
        x1: 10.688,
        x2: 74.946,
        y1: 41.282,
        y2: 41.282,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B090F5"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#1AA3FF"
    })))));
};

export { SvgAllContracts as ReactComponent };
//# sourceMappingURL=AllContracts.svg.es.js.map
